import React from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Loader from "../../../components/Loader";
import Row from "./Row";

const Table = ({ 
  sessions = [], 
  loading, 
  error, 
  noResults, 
  onStatusChange, 
  onDeleteSession, 
  onDuplicateSession 
}) => {

  if (loading) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.loading}>
          <Loader />
          <span>Chargement des sessions...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.error}>{error}</div>
      </div>
    );
  }

  if (noResults || sessions.length === 0) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.empty}>
          <p>Aucune session de formation trouvée.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        <div className={styles.row}>
        <div className={styles.col}></div>
          <div className={styles.col}>Nom</div>
          <div className={styles.col}>Date de début</div>
          <div className={styles.col}>Date de fin</div>
          <div className={styles.col}>Intervenant</div>
          <div className={styles.col}>Groupe</div>
          <div className={styles.col}>Statut</div>
        </div>
        {sessions.map((session, index) => (
          <Row
            item={session}
            key={session.id}
            index={index}
            onDelete={onDeleteSession}
            onDuplicate={onDuplicateSession}
          />
        ))}
      </div>
    </div>
  );
};

export default Table;
